/*
	404 Error component

	shown when 404 error is received
*/

<template>
	<div>
		<h1 class="red">404 error !!</h1>
	</div>

</template>

<script>
	export default {

		data () {
			return {
			}
		},
	}
</script>

<style>
	.red {
		color: #f00;
	}
</style>



// WEBPACK FOOTER //
// Error404View.vue?df9c4342